<template>
  <vx-card id="event-card" no-shadow class="p-0 m-0 pt-0" :class="{'mb-2': isSmallerScreen}">
    <div>
        <div class="post-header flex justify-between mb-2 pt-0">
          <div class="flex items-center">
            <div class="vx-card__title mb-3">
              <h6 class="success bold mb-2">EVENTOS SOBRE LA REVISIÓN DE LA SOLICITUD DE CRÉDITO</h6>
              <!-- <vs-button v-if="events.length > 0 && showExpanded" size="small" icon-pack="feather" type="border" icon="icon-eye" @click="showFullLog">Ver todos</vs-button> -->
            </div>
          </div>
          <!-- <div class="flex" v-if="!showExpanded">
            <vs-button v-if="events.length > 0" size="small" icon-pack="feather" type="border" icon="icon-eye" @click="showFullLog">Ver todos</vs-button>
          </div> -->
      </div>
      <div v-if="showExpanded && events.length > 0" class="comments-container mt-2">
        <vx-timeline :data="timeLineEvents"></vx-timeline>
        <!-- <ul class="user-comments-list">
          <li
            v-for="(log, l) in events"
            :key="l"
            class="commented-user flex items-center mb-1"
          >
            <div class="leading-tight">
              <p class="bold mb-1 text-md bold-dark">{{ logFrom(log) }}</p>
              <span class="text-xmd" style="white-space: pre-wrap">{{ escapedText(log.description) }}</span>
              <div class="flex items-left mt-1">
                 <vx-tooltip
                  color="dark"
                  position="right"
                  :text="logDateFormat(log.created_at)">
                  <feather-icon class="mr-2 time-tag-icon" icon="ClockIcon" svgClasses="h-3 w-3"></feather-icon> 
                  <span class="text-xs time-tag">{{ timeAgoFormat(log.created_at) }}</span>
                </vx-tooltip>
              </div>
              <vs-divider></vs-divider>         
            </div>            
          </li>
        </ul> -->
      </div>

      <div v-else-if="!showExpanded && events.length > 0">
        <vs-table stripe :data="events" :noDataText="noEventsText">
          <template slot="thead">
            <vs-th class="bold">ACTOR</vs-th>
            <vs-th class="bold">ACCIÓN</vs-th>
            <vs-th class="bold"></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="text-sm">
                {{ logFrom(tr)}}
              </vs-td>

              <vs-td  class="text-sm">
                {{ escapedText(tr.description)}}
              </vs-td>

              <vs-td >
                <vx-tooltip
                  color="dark"
                  position="top"
                  :text="logDateFormat(tr.created_at)">
                  <span class="text-xs time-tag">{{ timeAgoFormat(tr.created_at) }}</span>
                </vx-tooltip>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>

      <div v-else>
        <p>{{noEventsText}}</p>
      </div>
  
    </div>

    <vs-popup
        fullscreen
        title="Todos los eventos de revisión del proyecto"
        :active.sync="showAllEventsPopup">
        <div class="con-exemple-prompt">

          <vs-table stripe :data="allEvents" :noDataText="noEventsText">
            <template slot="thead">
              <vs-th class="bold">ACTOR</vs-th>
              <vs-th class="bold">ACCIÓN</vs-th>
              <vs-th class="bold">FECHA EVENTO</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="text-md">
                  {{ logFrom(tr)}}
                </vs-td>

                <vs-td class="text-md">
                  {{ escapedText(tr.description)}}
                </vs-td>

                <vs-td class="text-md">
                  {{logDateFormat(tr.created_at)}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-popup>

  </vx-card>
</template>

<script>
import dateHelper from "@mixins/dateHelper";

export default {
  name: "credit-events-log",
  mixins: [dateHelper],
  props: ["projectId"],
  data() {
    return {
      previewLimit: 10,
      boPreviewLimit: 2,
      showAllEventsPopup: false,
      allEvents: [],
      events: [],
      noEventsText: "No se han registrado eventos",
      timeLineEvents: []
    };
  },
  async mounted() {
    await this.getEvents();
  },
  computed: {
    showExpanded(){
      return this.isBackoffice;
    },
    isBackoffice(){
      return process.env.VUE_APP_IS_BACKOFFICE == 'true';
    },
    isSmallerScreen(){
      return this.$store.state.windowWidth <= 1200
    }
  },
  methods: {
    async getEvents(pid = this.projectId) {
      try {
        let path = "/getCreditRequestEvents";
        let response = await axios.get(`/api/v1/project/${pid}${path}`);
        this.allEvents = response.data;
        const limit = this.isBackoffice ? this.boPreviewLimit : previewLimit;
        this.events = this.allEvents.slice(0, limit);
        this.timeLineEvents = [];
        this.allEvents.forEach(event => {
          this.timeLineEvents.push({
            color: "dark",
            icon: "BellIcon",
            title: this.logFrom(event),
            desc: event.description,
            time: (event.created_at)
          })
        });
       
      } catch (e) {
        this.warn(e);
      }
    },
    async showFullLog() {
      await this.getEvents();
      this.showAllEventsPopup = true;
    },
    logFrom(event) {
      if(event.supplier_id != null){
        return "Proveedor"
      }
      else if(event.rg_user_id != null){
        let r = "RedGirasol";
        if(this.isBackoffice){
          r += ` (${event.rg_user_email})`;
        }
        return r;
      }
      else if(event.client_id != null){
        return "Solicitante"
      }
    },
    entryClass(uid) {
      return this.userId == uid ? "mine" : "other";
    },
    escapedText(t){
      return t.split('<br />').join('\n');
    },
    iconForEvent(event_int){
      
    }
  }
};
</script>

<style scoped>
.log-table {
  border-collapse: separate;
  border-spacing: 6px;
}
.log-icon {
  text-align: center;
}
td.log-content {
  text-align: left;
  border: 1px solid;
  width: 100%;
}

td.empty-log {
  text-align: center;
  border: 1px solid;
  background-color: #e8e8e8;

  font-style: italic;
}

.log-from {
  margin-right: 5px;
}

td.log-date {
  text-align: right;
  min-width: 120px;
  font-size: 11px;
  font-family: "gilroybold";
  vertical-align: bottom;
  border: none;
  color: white;
}

.log-entry.mine .log-date {
  background-color: #c0d760;
}

.log-entry.other .log-date {
  background-color: #fece6b;
}

.time-tag, .time-tag-icon {
  color: rgba(var(--vs-primary), 1) !important;
}

.comments-container {
  height: 20rem !important;
  overflow: auto;
}

#event-card .vx-card .vx-card__collapsible-content .vx-card__body {
  padding-top: 0 !important;
}
</style>
